import React, {useState} from "react";
import {
    Heading,
    ToggleSwitch
} from "pac-ux-components";
import usePsps from "../../hooks/usePsps";
import Loading from "../Loading";
import PaymentMethodModal from "./PaymentMethodModal";

function PaymentProviderList() {
    const {psps, loading, setLoading, error, setError} = usePsps();
    const [editingPayMethods, setEditingPayMethods] = useState(null);

    const handleEnablePsp = async (pspId) => {

    }

    const handleDisablePsp = async (pspId) => {

    };

    const handleCloseModal = () => {
        setEditingPayMethods(null);
        window.location.reload();
    }

    function handleClickPayMethods(pspid) {
        setEditingPayMethods(pspid);
    }

    if (loading) return (<Loading/>);

    if (error) return <p>Error: {error}</p>;


    return (<div className="PaymentProviders" style={{width: 1047}}>

        <Heading color={'#10304C'} style={{paddingTop: 56, paddingBottom: 16}}

        >Payment</Heading>


        <table width="1047px" className="Table" style={{}}>
            <thead>
            <tr style={{fontWeight: 600, height: 48, fontSize: 16, fontFamily: 'Inter', border: "thin solid #E0E0E0"}}>
                <td width="520" style={{paddingLeft: 32}}>Payment Provider</td>
                <td width="400">Payment Methods</td>

            </tr>
            </thead>
            <tbody>
            {psps.map((psp, index) => (<tr key={psp.id} style={{
                height: 48,
                fontSize: 16,
                fontWeight: 400,
                backgroundColor: index % 2 === 0 ? '#EDEDED' : '#FFFFFF',
                border: "thin solid #E0E0E0"
            }}>
                <td style={{paddingLeft: 32}}>
                    {psp.name}
                </td>
                <td>
                    <span onClick={() => handleClickPayMethods(psp.id)} style={{cursor: 'pointer'}}>{psp.payments}<img
                        src="/image/pencil.svg" width={24} height={23} style={{marginLeft:'20px'}} alt="Change"/></span>
                </td>

            </tr>))}
            </tbody>
        </table>

        {editingPayMethods !== null && (
            <PaymentMethodModal
                psp={editingPayMethods}
                display={editingPayMethods === null ? false : true}
                closeModal={ handleCloseModal }/>
        )}


    </div>);
}

export default PaymentProviderList;